import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["notice"]

  disconnect() {
    clearTimeout(this._noticeTimeout)
  }

  // Stimulus lifecycle callback: fires when a notice target is added to the DOM
  noticeTargetConnected(element) {
    clearTimeout(this._noticeTimeout)
    this._noticeTimeout = setTimeout(() => {
      element.classList.remove("opacity-100")
      element.classList.add("opacity-0")
      setTimeout(() => element.classList.add("hidden"), 300)
    }, 2500)
  }
}
